import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'base-ui'

import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'
import { MarketplacePartnerRegisterPageFormRadioField } from '../MarketplacePartnerRegisterPageFormRadioField'

export const MarketplacePartnerRegisterPageFormMarketing: FC = () => {
  const { formState } = useMarketplacePartnerRegisterPageContext()
  const retailMediaUrl = 'https://retailmedia.redcare-pharmacy.com/de/home'

  formState.use()

  return (
    <div className="flex flex-col gap-10">
      <Heading level={2} size="l">
        <FormattedMessage id="marketplacePartnerRegisterPage.marketing.title" />
      </Heading>
      <MarketplacePartnerRegisterPageFormRadioField
        fieldName="retailMediaMarketing"
        label={
          <FormattedMessage
            id="marketplacePartnerRegisterPage.marketing.retailMediaMarketing.label"
            values={{
              retailMediaLink: (
                <a
                  href={retailMediaUrl}
                  key={retailMediaUrl}
                  rel="noreferrer"
                  target="_blank"
                >
                  {retailMediaUrl}
                </a>
              ),
            }}
          />
        }
      />
    </div>
  )
}
